import React, { useState } from 'react';
import Select, { components } from 'react-select';
import MoreFilter from '../component/MoreFilterOption';
import { StartDate, EndDate, PaymentDue } from '../component/DatePicker';
import moment from 'moment';
import { DATE_RANGES } from '@src/config/constant';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
import { useLanguage } from '../../src/context/LanguageContext';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: string;
  label: string;
};

const LeadListFilter = (props: any) => {
  const { submitHandler, selectedFilters, setSelectedFilters, config, partnerList,paymentMethod,assignUsers } = props;
  const [showDueRange, setShowDueRange] = useState<any>(false);
  
  const {translations} = useLanguage();
  const handleChange = (selectedOption: any, key: string) => {
    setSelectedFilters((prev: any) => {
      let updatedFilters = { ...prev };

      if (key === 'start_date' || key === 'end_date' || key === 'due_date') {        
        if (selectedOption.length === 2) {
          updatedFilters[`${key}_from`] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
          updatedFilters[`${key}_to`] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
        } else {
          updatedFilters[`${key}_from`] = selectedOption[0]?.format("YYYY-MM-DD");
          updatedFilters[`${key}_to`] = null;
        }
      } else if (key === 'searchKeyword') {
        updatedFilters[key] = selectedOption.target.value;
      } else if (key === 'payment_due') {
        if (selectedOption?.value === 'custom') {
          setShowDueRange(true);
        } else {
          if (selectedOption?.value === 'next_7_days') {
            updatedFilters['due_date_from'] = moment().format("YYYY-MM-DD");
            updatedFilters['due_date_to'] = moment().add(DATE_RANGES.NEXT_DAYS_7, "days").format("YYYY-MM-DD");
          } else if (selectedOption?.value === 'next_14_days') {
            updatedFilters['due_date_from'] = moment().format("YYYY-MM-DD");
            updatedFilters['due_date_to'] = moment().add(DATE_RANGES.NEXT_DAYS_14, "days").format("YYYY-MM-DD");
          } else if (selectedOption?.value === 'this_month') {
            updatedFilters['due_date_from'] = moment().startOf("month").format("YYYY-MM-DD");
            updatedFilters['due_date_to'] = moment().endOf("month").format("YYYY-MM-DD");
          }
          setShowDueRange(false);
        }
        updatedFilters[key] = selectedOption?.value || null;
      }else if (selectedOption instanceof Array) {
        // For multi-select (array of options)
        updatedFilters[key] = selectedOption.map((e) => e.value);
      } else {
        updatedFilters[key] = selectedOption?.value || null;
      }

      return updatedFilters;
    });
  };
  
  return (
    <div className="lead-list-filter">
      <div className="filter-filed-form filter-left-panel">
        {filters.leadListFilters(translations).map((filter: any) => renderFilterField(filter, { selectedFilters, handleChange, translations,CustomValueContainer,
          options:{
              payment_due_in: config?.payment_due_in, 
              partnerList:partnerList,
              lead_types: config?.lead_types,
          },
          showDueRange
        }))}
        {/* <fieldset className="search-bx">
          <div className="material">
            <input
              type="text"
              placeholder="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
              name="search"
              className="form-input"
              title="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
              aria-label="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
              onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""} 
            />
            <i className="ic-search"></i>
          </div>
        </fieldset>

        <fieldset className="date-filed">
          <div className="material">
            <StartDate selectedFilters={selectedFilters} handleChange={handleChange}/>
          </div>
        </fieldset>
    
        <fieldset className="date-filed">
          <div className="material">
            <EndDate selectedFilters={selectedFilters} handleChange={handleChange}/>
          </div>
        </fieldset>

        <fieldset className="single-select">
          <div className="material">
            <Select<OptionType>
              components={{ ValueContainer: CustomValueContainer }}
              options={config['payment_due_in']}
              placeholder="Payment Due In"
              className="react-select"
              classNamePrefix="react-select"
              isClearable
              onChange={(e: any) => handleChange(e, 'payment_due')}
              value={config['payment_due_in']?.find((option: any) => option.value === selectedFilters.payment_due) || null}
            />
          </div>
        </fieldset>

        {
          showDueRange && 
          <fieldset className="date-filed">
            <div className="material">
              <PaymentDue selectedFilters={selectedFilters} handleChange={handleChange} />
            </div>
          </fieldset>
        } */}
        
      </div>

      <div className="more-filter">
        <MoreFilter submitHandler={submitHandler} selectedFilters={selectedFilters} paymentMethod={paymentMethod} setSelectedFilters={setSelectedFilters} config={config} partnerList={partnerList} assignUsers={assignUsers}/>
      </div>
    </div>
  );
};

export default LeadListFilter;
